<template>
    <div>
        <Card title="我的数据集" icon="ios-options" :padding="0" shadow style="border;">
            <Collapse simple accordion>
                <Panel name="1" v-for="(item,idx) in contestInfo.datasets_info" :name="idx.toString()">
                    {{item.name}}
                    <p slot="content">
                        <List>
                            <ListItem v-for="(value) in item.files" @click.native="copyPath(item.mount_path,value.name)" style="cursor:pointer">{{value.name}}</ListItem>
                        </List>
                    </p>
                </Panel>
            </Collapse>
        </Card>
    </div>
</template>
<script>
    export default {
        name: "Data",
        props:{
            contestInfo:{
                type:Object,
                required:true,
            }
        },
        methods:{
            // 复制数据集路径
            copyPath(mount_path,name){
                let  path = mount_path + '/' + name;
                var oInput = document.createElement('input');
                oInput.value = path;
                document.body.appendChild(oInput);
                if(oInput.createTextRange) {//ie
                    oInput.select();
                }else{//firefox/chrome
                    oInput.setSelectionRange(0, oInput.value.length);
                    oInput.focus();
                };
                document.execCommand("Copy");
                oInput.className = 'oInput';
                oInput.style.display = 'none';
                this.$Message.success("复制成功");
            }
        }
    }
</script>
<style scoped>
    .ivu-list-item {
        cursor: pointer;
    }
</style>
